<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { AppMultiSelectSearchable } from '@shared/ui/selects'
import { NativeSelect } from '@shared/ui/fields'

import { useFiltersCustomers } from '../../model/list/filters-customers.hook'

defineOptions({
  name: 'FiltersCustomers',
})

const {
  refSearch,
  refDateRange,
  refStages,
  statusValue,
  statusOptions,
  stageOptions,
  setStatus,
  isLoading,
  submitSearch,
  clearFilters,
} = useFiltersCustomers()
</script>

<template>
  <div class="filters-customers">
    <AppInput
      v-model="refSearch"
      class="filters-customers__search"
      label="Search"
      placeholder="Search"
      :disabled="isLoading"
      @keyup:enter="submitSearch"
    />

    <FilterDateRange
      v-model="refDateRange"
      class="filters-customers__date"
      label="Date"
      placeholder="Search"
      :disabled="isLoading"
    />

    <AppMultiSelectSearchable
      v-model="refStages"
      class="filters-customers__stage"
      :options="stageOptions"
      label="Stage"
      placeholder="All"
      clearable
      :disabled="isLoading"
    />

    <NativeSelect
      class="filters-customers__status"
      name="select_customer_status"
      label="Status"
      :options="statusOptions"
      :value="statusValue"
      :disabled="isLoading"
      @change="setStatus"
    />

    <BtnPrimary
      class="filters-customers__button"
      text="Search"
      element-width="auto"
      :disabled="isLoading"
      @click="submitSearch"
    />
    <BtnIcon
      :icon="faFilterCircleXmark"
      color="red"
      tooltip-text="Clear filters"
      :disabled="isLoading"
      @click="clearFilters"
    />
  </div>
</template>

<style scoped lang="scss" src="./FiltersCustomers.scss" />
